import { useEffect, useState } from 'react';
import { Box, Card, CardContent, Dialog, Grid, IconButton, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslation } from 'react-i18next';
import CurrencyLiraIcon from '@mui/icons-material/CurrencyLira';
import { OrderCommand } from '../../../../../services/command';
import DiscountIcon from '@mui/icons-material/Info';
import DiscountInfo from './OrderInformationCard/components/DiscountInfo';
import Helper from '../../../../../utils/helper';
import './OrderPriceCard.scss';
import { OPC, uodCls } from '../userOrderDetails.classes';

const rowSx = {
    marginBottom: '5px',
    '& span': {
        fontWeight: 'bold',
    },
    '& span:last-child': {
        float: 'right',
    },
    '&::after': {
        content: '""',
        display: 'table',
        clear: 'both',
    },
};

function OrderPriceCard({ datas }: any) {
    const { t } = useTranslation();
    const saleOrderPrice = datas?.saleOrderPriceModels;

    const [openBarkodModal, setOpenBarkodModal] = useState(false);
    const [refundAmountData, setRefundAmountData] = useState<any>();
    const [fontSize, setFontSize] = useState('');

    const selectedCountry = JSON.parse(localStorage.getItem('selectedCountry') || '{}');
    const currency =
        selectedCountry?.supportedCurrencies?.find(
            (currency: any) => currency?.currencyId === refundAmountData?.currencyId
        )?.shortCode || '';
    useEffect(() => {
        if (!datas?.orderId) return;

        let req = {
            orderId: datas.orderId,
            orderNumber: datas.orderNumber,
            orderDate: datas.orderDate,
        };
        OrderCommand.GetOrderAllRefundDetails(req).then((res: any) => {
            if (
                (res?.paymentPendingAmount && res?.paymentPendingAmount > 0) ||
                (res?.completedRefundAmount && res?.completedRefundAmount > 0)
            ) {
                setRefundAmountData(res);
                setFontSize('9px');
            } else {
                setFontSize('14px');
            }
        });
    }, [datas?.orderId]);

    const handleOpenBarkodModal = () => {
        setOpenBarkodModal(true);
    };

    const handleCloseBarkodModal = () => {
        setOpenBarkodModal(false);
    };

    return (
        <>
            <Dialog
                open={openBarkodModal}
                onClose={handleCloseBarkodModal}
                slotProps={{
                    paper: {
                        className: OPC.dialogDiscountPaper,
                    },
                }}
                sx={{
                    '& .MuiDialog-container': {
                        '& .MuiPaper-root': {
                            width: '100%',
                            minWidth: '900px',
                        },
                    },
                }}
            >
                <DiscountInfo discounts={datas?.orderDiscountModel} />
            </Dialog>
            <Grid
                sx={{ boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' }}
                className={uodCls('orderPrice', OPC.root)}
                size={{
                    xs: 12,
                    sm: 12,
                    md: 12
                }}>
                <Card className={OPC.headerCard} sx={{ padding: '1rem', display: 'flex' }}>
                    <CurrencyLiraIcon className={OPC.headerIcon} style={{ marginTop: '0.5rem' }} />
                    <h3 className={OPC.title} style={{ marginLeft: '0.5rem' }}>
                        <strong> {t('orderDetail.orderPrice')}</strong>
                    </h3>
                </Card>
                <div className={OPC.divider} style={{ height: '2px', background: 'lightGray' }}></div>
                <Card className={OPC.bodyCard} sx={{ height: '180px' }}>
                    <CardContent className={OPC.bodyContent}>
                        {saleOrderPrice ? (
                            <>
                                <div className={uodCls('order-price-scroll', OPC.scrollArea)}>
                                    <Box className={OPC.rowPrice} sx={{ ...rowSx, fontSize: fontSize }}>
                                        <span>{t('orderDetail.price')}:</span>
                                        <span>{saleOrderPrice?.price}</span>
                                    </Box>
                                    <Box className={OPC.rowDiscount} sx={{ ...rowSx, fontSize: fontSize }}>
                                        <span>{t('orderDetail.discount')}:</span>
                                        {datas?.orderDiscountModel && datas?.orderDiscountModel.length > 0 && (
                                            <IconButton
                                                className={OPC.inputButtonDiscountDetails}
                                                onClick={handleOpenBarkodModal}
                                            >
                                                <DiscountIcon color="secondary" />
                                            </IconButton>
                                        )}
                                        <span>{saleOrderPrice?.discount}</span>
                                    </Box>
                                    <Box className={OPC.rowSubTotal} sx={{ ...rowSx, fontSize: fontSize }}>
                                        <span>{t('orderDetail.subTotal')}:</span>
                                        <span>{saleOrderPrice?.subPrice}</span>
                                    </Box>
                                    <Box
                                        className={OPC.rowShippingFee}
                                        sx={{
                                            ...rowSx,
                                            fontSize: fontSize,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <span>{t('orderDetail.shippingFee')}:</span>
                                        <div className={OPC.cargoCampaignWrap} style={{ flex: 1, textAlign: 'center' }}>
                                            {datas?.cargoCampaignName && (
                                                <p
                                                    style={{
                                                        color: 'red',
                                                        fontStyle: 'italic',
                                                        margin: 0,
                                                    }}
                                                >
                                                    {' '}
                                                    <p style={{ color: 'red', fontStyle: 'italik' }}>
                                                        {' '}
                                                        ({datas.cargoCampaignName})
                                                    </p>
                                                </p>
                                            )}
                                        </div>
                                        <span>{saleOrderPrice?.shippingPrice}</span>
                                    </Box>

                                    <Box className={OPC.rowAdditionalFee} sx={{ ...rowSx, fontSize: fontSize }}>
                                        <span>{t('orderDetail.additionalFee')}:</span>
                                        <span>{saleOrderPrice?.additionalPrice}</span>
                                    </Box>
                                    <Box className={OPC.rowTotalAmount} sx={{ ...rowSx, fontSize: fontSize }}>
                                        <span>{t('orderDetail.totalAmount')}:</span>
                                        <span>{saleOrderPrice?.totalPrice}</span>
                                    </Box>
                                    {refundAmountData?.completedRefundAmount > 0 && (
                                        <Box
                                            className={OPC.rowCompletedRefund}
                                            sx={{ ...rowSx, color: 'red', fontSize: fontSize }}
                                        >
                                            <span>{t('orderDetail.completedRefund')}:</span>
                                            <span>
                                                {Helper.formatCurrencyByCountry(
                                                    Number(refundAmountData?.completedRefundAmount),
                                                    selectedCountry?.countryCode
                                                )}{' '}
                                                {currency}
                                            </span>
                                        </Box>
                                    )}
                                    {refundAmountData?.paymentPendingAmount > 0 && (
                                        <Box
                                            className={OPC.rowPendingRefund}
                                            sx={{ ...rowSx, color: 'red', fontSize: fontSize }}
                                        >
                                            <span>{t('orderDetail.pendingRefund')}:</span>
                                            <span>
                                                {Helper.formatCurrencyByCountry(
                                                    Number(refundAmountData?.paymentPendingAmount),
                                                    selectedCountry?.countryCode
                                                )}{' '}
                                                {currency}
                                            </span>
                                        </Box>
                                    )}
                                </div>
                            </>
                        ) : (
                            <Grid
                                className={OPC.lockedGrid}
                                container
                                style={{ height: '100%' }}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <div
                                    className={OPC.lockedInner}
                                    style={{
                                        textAlign: 'center',
                                        position: 'relative',
                                        pointerEvents: 'none',
                                    }}
                                >
                                    <LockIcon
                                        className={OPC.lockedIcon}
                                        sx={{
                                            fontSize: 40,
                                            color: 'blue',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            pointerEvents: 'none',
                                        }}
                                    />
                                    <div
                                        className={OPC.lockedBlurContent}
                                        style={{
                                            filter: 'blur(5px)',
                                            color: 'gray',
                                            userSelect: 'none',
                                        }}
                                    >
                                        <Typography variant="body2" style={{ userSelect: 'none' }}>
                                            Ad Soyad: Test
                                        </Typography>
                                        <Typography variant="body2" style={{ userSelect: 'none' }}>
                                            Telefon: 0555 555 55 55
                                        </Typography>
                                        <Typography variant="body2" style={{ userSelect: 'none' }}>
                                            E-Posta: ornek@lcwaikiki.com
                                        </Typography>
                                    </div>
                                </div>
                            </Grid>
                        )}
                    </CardContent>
                </Card>
            </Grid>
        </>
    );
}

export default OrderPriceCard;
